import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 18,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 18,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 18,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        date: 'today',
    },
    components: [
        {
            name: 'page-header',
            key: 'c1',
            props: {
                header: {
                    title: 'ui.mm.sub-menu-excel-addin-exposure-reports',
                    path: '',
                },
                rhsComponents: [
                    {
                        name: 'date-picker',
                    },
                ],
            },
        },
        {
            name: 'exposure-reports-wrapper',
            key: 'c2',
            apiDetails: {
                endpoint: `reports/exposure?`,
                endpointParams: {
                    to_date: 'date',
                    parent_user_ids: '*,user_id',
                    user_asset_class: 'user_asset_class',
                    canopy_asset_class: 'canopy_asset_class',
                    child_display_name: 'child_display_name',
                    contract_currency: 'contract_currency',
                },
            },
            props: {
                requiredQueryFields: ['parent_user_ids', 'to_date'],
                clientSideSearch: true,
                clientSideSort: true,
                clientSideSortParentRows: true,
                showPagination: false,
                showDownloadOn: ['desktop'],
                showSearchOn: [],
                showColumnFilterOn: ['desktop', 'tablet'],
                downloadCurrentData: false,
                showFilterOn: [],
                columns: [],
                defaultColumns: [
                    'ticker',
                    'child_display_name',
                    'base_currency',
                    'quantity',
                    'contract_currency',
                    'price_close',
                    'database_valuation',
                    'derived_valuation',
                    'delta_amount_base_ccy',
                    'fx_exposure_amount_base_ccy',
                ],
                filterColumns: true,
                footerColumns: [
                    'database_valuation',
                    'derived_valuation',
                    'delta_amount_base_ccy',
                    'fx_exposure_amount_base_ccy',
                    'valuation_difference',
                ],
                ga_event_name: 'Exposure Reports ',
            },
        },
    ],
};
